$(function () {
  let p = $('body').attr('p');
  let event_id = $('body').attr('event_id');

  $(document).on('click', '.cash-exchange-button', function () {
    showCashExchangeModal();
  });

  $(document).on('input', '#cash-exchange-input', function () {
    // prevent minus or plus special characters but accept decimal or comma and only accept one of the periods or commas and kept only first separator, e.g., "12,.34" should kept as "12,34", "12.,34" should keep as "12.34"
    this.value = this.value.replace(/[^0-9.,]/g, '');
    const firstSeparatorIndex = Math.min(
      ...['.', ','].map((sep) => {
        const index = this.value.indexOf(sep);
        return index === -1 ? Infinity : index;
      })
    );
    if (firstSeparatorIndex !== Infinity) {
      const before = this.value.slice(0, firstSeparatorIndex + 1);
      const after = this.value
        .slice(firstSeparatorIndex + 1)
        .replace(/[.,]/g, '');
      this.value = before + after;
    }
  });

  $(document).on('submit', '#cash-exchange-form', function (e) {
    e.preventDefault();
    const cashExchangeValue = parseFloat(
      $('#cash-exchange-input').val().replace(',', '.') || 0
    );

    setClassicLocationCart({
      ...locationCart,
      checkout_type: 'normal',
      exchange_amount: cashExchangeValue || 0,
    })?.always(function () {
      $('#cash-exchange-modal').modal('hide');
    });
  });

  function showCashExchangeModal() {
    $('#cash-exchange-modal')
      .on('shown.bs.modal', function () {
        $('#cash-exchange-input').focus();
      })
      .on('hidden.bs.modal', function () {
        $('#cash-exchange-input').blur();
      })
      .modal('show');
  }

  if (p == 'exchange_report') {
    let start_date = $('#start_date').val();
    let end_date = $('#end_date').val();
    let order_by = $('#order_by').val();
    let order_by_direction = $('#order_by_direction').val();
    let page = $('#page').val();
    let exchangeReportAjaxLock = false;

    $(document).on('change', '#start_date, #end_date', function () {
      start_date = $('#start_date').val();
      end_date = $('#end_date').val();

      search();
    });

    $(document).on('click', '.sort', function () {
      order_by = $(this).prop('id');
      order_by_direction = $(this).data('order-direction');

      search();
    });

    $(document).on('click', '.pagination a', function (e) {
      e.preventDefault();
      page = parseInt($(this).attr('href').substring(6));

      search();
    });

    $(document).on('click', '#export-exchange-report', function (e) {
      e.preventDefault();

      const disabledOnClick = $('#export-exchange-report');
      const btnWidth = disabledOnClick.outerWidth();
      disabledOnClick.css('width', btnWidth + 'px');
      disabledOnClick.prop('disabled', true);
      disabledOnClick.html('<i class="spinner-border spinner-border-sm"></i>');

      const url = `/api/v1/private/cash-exchange/export-report?start_date=${start_date}&end_date=${end_date}&location_id=${event_id}`;
      window.location.href = url;

      disabledOnClick.prop('disabled', false);
      disabledOnClick.html('Eksport');
    });

    function search() {
      if (!exchangeReportAjaxLock) {
        exchangeReportAjaxLock = true;

        $.ajax({
          type: 'POST',
          url: '/api/v1/private/cash-exchange/search',
          data: {
            start_date,
            end_date,
            order_by,
            order_by_direction: order_by_direction.toUpperCase(),
            page,
          },
        })
          .done(function (response) {
            const { data } = response;
            if (
              data.html != undefined &&
              data.html != null &&
              data.html != ''
            ) {
              $('#cash-exchange-list').html(data.html);
            }
          })
          .fail(function (data) {
            if (
              data.responseJSON.redirect_url !== undefined &&
              data.responseJSON.redirect_url !== null
            ) {
              document.location.href = data.responseJSON.redirect_url;
            }
          })
          .always(function () {
            exchangeReportAjaxLock = false;
          });
      }
    }
  }
});
